export default __webpack_public_path__ + "static/media/Scholten_head.ac5859ce.jpg";